function CheckIcon(props: any) {
  return (
    <svg
      width='14'
      height='11'
      viewBox='0 0 14 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.3327 2L4.99935 9.33333L1.66602 6'
        stroke='#2393B8'
        strokeWidth='2'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default CheckIcon
